// front-end/multimodal/src/FontSelector.tsx
import React, {useEffect, useContext} from 'react';
import {MyContext} from "./Context";
import './FontSelector.css';

const FontSelector: React.FC = () => {
    const { isScriptFontState, setIsScriptFontState } = useContext(MyContext);

    useEffect(() => {
        const handleKeyDown = (event: KeyboardEvent) => {
            if (event.key === 'f' || event.key === 'F') {
                setIsScriptFontState(!isScriptFontState);
            }
        };

        window.addEventListener('keydown', handleKeyDown);

        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [setIsScriptFontState, isScriptFontState]);


    return (
        <button title="Change font, 'f'" className={"circle-button" + (isScriptFontState ? "" : " thai-script-font")} onClick={() => { setIsScriptFontState(!isScriptFontState) }}>
            <span>ก</span>
        </button>
    );
}

export default FontSelector;